import React from 'react';

import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';

const styles = {
  additiveChip: {
    backgroundColor: 'surface.white',
    borderColor: 'graphic.light',
    borderStyle: 'solid',
    borderWidth: '1px',
    color: 'success.main',
  },
  chips: {
    '.MuiChip-root': {
      fontSize: '12px',
      height: 'unset',
      mb: 0.5,
      mr: 0.5,
      px: 0,
      py: 0.25,
    },
    ml: 0,
    mr: 0.5,
    my: 0.5,
  },
  productChip: {
    backgroundColor: 'primary.light',
    borderWidth: '1px',
  },
  row: {
    display: 'flex',
    flexDirection: 'column',
    mt: 1.5,
    position: 'relative',
  },
  skeletonBanner: {
    clipPath: 'polygon( 0% 0%, 0% 100%, 50% 85%, 100% 100%, 100% 0% )',
    height: 66,
    width: 47,
  },
  skeletonChip: { display: 'inline-block', mr: 0.25 },
};

const TerminalCardSkeleton = () => (
  <>
    <Box>
      <Box sx={styles.row}>
        <Skeleton>
          <Typography sx={{ fontSize: '18px' }}>TERMINAL ADDRESS</Typography>
        </Skeleton>
        <Skeleton>
          <Typography sx={{ fontSize: '14px' }}>00 mi.</Typography>
        </Skeleton>
      </Box>
      <Box sx={styles.row}>
        <Skeleton>
          <Typography sx={{ fontSize: '12px' }}>Base Products</Typography>
        </Skeleton>
        <Box sx={styles.chips}>
          {['A', 'D', 'D5', 'DE', 'E', 'H', 'NV', 'X', 'X1', 'L'].map(label => (
            <Skeleton key={label} sx={styles.skeletonChip}>
              <Chip label={label} sx={styles.productChip} />
            </Skeleton>
          ))}
        </Box>
      </Box>
      <Box sx={styles.row}>
        <Skeleton>
          <Typography sx={{ fontSize: '12px' }}>Additives</Typography>
        </Skeleton>
        <Box sx={styles.chips}>
          {['BP IVD', 'CNX PDA', 'CNX PDAC', 'CNX WINTER', 'FHR PDA'].map(label => (
            <Skeleton key={label} sx={styles.skeletonChip}>
              <Chip label={label} sx={styles.additiveChip} />
            </Skeleton>
          ))}
        </Box>
      </Box>
    </Box>
    <Skeleton sx={styles.skeletonBanner} variant="rectangular" />
  </>
);

export default TerminalCardSkeleton;
